import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MomentModule } from 'ngx-moment';
import { MaterialModule } from 'src/app/shared/material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxLoadingModule, ngxLoadingAnimationTypes } from 'ngx-loading';
import { OutBankDetailF2Component } from './out-bank-detail-f2/out-bank-detail-f2.component';
import { OutIdProofF3Component } from './out-id-proof-f3/out-id-proof-f3.component';
import { IConfig, NgxMaskModule } from 'ngx-mask';
import { StripHtmlModule } from 'src/app/shared/strip-html/strip-html.module';
import { HttpClientModule } from '@angular/common/http';
import { OutIdProofGstComponent } from './out-id-proof-gst/out-id-proof-gst.component';
import { BirthCertificateFormComponent } from './IdVerificationForms/birth-certificate-form/birth-certificate-form.component';
import { CentreLinkFormComponent } from './IdVerificationForms/centre-link-form/centre-link-form.component';
import { CitizenshipFormComponent } from './IdVerificationForms/citizenship-form/citizenship-form.component';
import { DescentFormComponent } from './IdVerificationForms/descent-form/descent-form.component';
import { DriverLicenceFormComponent } from './IdVerificationForms/driver-licence-form/driver-licence-form.component';
import { ElectoralRollFormComponent } from './IdVerificationForms/electoral-roll-form/electoral-roll-form.component';
import { ImmiCardFormComponent } from './IdVerificationForms/immi-card-form/immi-card-form.component';
import { MarriageCertificateFormComponent } from './IdVerificationForms/marriage-certificate-form/marriage-certificate-form.component';
import { MedicareFormComponent } from './IdVerificationForms/medicare-form/medicare-form.component';
import { NameChangeFormComponent } from './IdVerificationForms/name-change-form/name-change-form.component';
import { PassportFormComponent } from './IdVerificationForms/passport-form/passport-form.component';
import { VisaFormComponent } from './IdVerificationForms/visa-form/visa-form.component';
import { OutAddressComponent } from './out-address/out-address.component';





const maskConfigFunction: () => Partial<IConfig> = () => {
    return {
        validation: true
    };
};

@NgModule({
    declarations: [OutBankDetailF2Component, OutIdProofF3Component, OutIdProofGstComponent,
        DriverLicenceFormComponent, 
        PassportFormComponent, 
        ImmiCardFormComponent, 
        BirthCertificateFormComponent, 
        CentreLinkFormComponent, 
        CitizenshipFormComponent, 
        DescentFormComponent, 
        MarriageCertificateFormComponent, 
        MedicareFormComponent, 
        NameChangeFormComponent, 
        VisaFormComponent,
        ElectoralRollFormComponent,
        OutAddressComponent,
        ],
    exports: [OutBankDetailF2Component, OutIdProofF3Component, OutIdProofGstComponent, DriverLicenceFormComponent, OutAddressComponent,
        PassportFormComponent, 
        ImmiCardFormComponent, 
        BirthCertificateFormComponent, 
        CentreLinkFormComponent, 
        CitizenshipFormComponent, 
        DescentFormComponent, 
        MarriageCertificateFormComponent, 
        MedicareFormComponent, 
        NameChangeFormComponent, 
        VisaFormComponent,
        ElectoralRollFormComponent], 
    imports: [
        CommonModule,
        MomentModule,
        MaterialModule,
        FormsModule,
        ReactiveFormsModule,
        StripHtmlModule,
        HttpClientModule,
        NgxLoadingModule.forRoot({
            animationType: ngxLoadingAnimationTypes.circle,
            backdropBackgroundColour: 'rgba(0,0,0,0.3)',
            backdropBorderRadius: '5px',
            primaryColour: '#43A047',
            secondaryColour: '#444444',
            tertiaryColour: '#444444',
        }),
        NgxMaskModule.forRoot(maskConfigFunction),
    ],
})
export class OuterSharedModule { }
